import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const actionTypesColors = {
  cell_phone_detected: { color: "#FFB2B2" },
  closed: { color: "#FFC3B2" },
  connection_restored: { color: "#FFCEB2" },
  copy_paste: { color: "#FFDAB2" },
  custom: { color: "#FFE5B2" },
  displays_check_manual_disabled: { color: "#FFEEB2" },
  displays_check_manual_enabled: { color: "#FFF7B2" },
  earphone_detected: { color: "#F0FFB2" },
  extension_detected: { color: "#D2FFB2" },
  extension_detector_manual_disabled: { color: "#B2FFC3" },
  eye_away: { color: "#9AFEAF" },
  finished: { color: "#9AFEE6" },
  focus_detector_manual_disabled: { color: "#9AF4FE" },
  focus_down: { color: "#9AD9FE" },
  focus_restored: { color: "#9AC2FE" },
  fullscreen_closed: { color: "#9AAFFE" },
  fullscreen_mode_manual_disabled: { color: "#AF9AFE" },
  head_depth: { color: "#C09AFE" },
  head_empty: { color: "#E39AFE" },
  head_identity: { color: "#FC9AFE" },
  head_identity_manual_disabled: { color: "#FE9ADB" },
  head_identity_manual_enabled: { color: "#FE9A9B" },
  head_many: { color: "#FE7477" },
  head_mismatch: { color: "#FE74A7" },
  head_restored: { color: "#FE74CE" },
  head_rotated: { color: "#FE74F7" },
  head_tracking_force_disabled: { color: "#E274FE" },
  head_tracking_manual_disabled: { color: "#B074FE" },
  head_tracking_manual_enabled: { color: "#9074FE" },
  main_camera_manual_disabled: { color: "#747BFE" },
  main_camera_manual_enabled: { color: "#7499FE" },
  mic_muted: { color: "#74B7FE" },
  multiple_screen: { color: "#74D2FE" },
  noise_detect: { color: "#74ECFE" },
  noise_detector_manual_disabled: { color: "#74FEEE" },
  noise_detector_manual_enabled: { color: "#74FED2" },
  object_detected: { color: "#74FEA4" },
  opened: { color: "#7BFE74" },
  proctoring_policy_agree: { color: "#B5FE74" },
  read_clipboard_manual_enabled: { color: "#E7FE74" },
  screen_share_force_disabled: { color: "#FEF074" },
  screen_share_manual_disabled: { color: "#FED074" },
  second_camera_focused: { color: "#FEB774" },
  second_camera_manual_disabled: { color: "#FE9E74" },
  second_camera_manual_enabled: { color: "#FE8074" },
  second_camera_unfocused: { color: "#FE7474" },
  speech_detect: { color: "#E8BA4E" },
  speech_detector_manual_disabled: { color: "#30CC7E" },
  started: { color: "#7997DD" },
  task_process_detected: { color: "#A675DB" },
  usb_device_detected: { color: "#EC6399" },
};